






































































































import { Component, Prop, Vue } from 'vue-property-decorator'

import Version from '@/models/version'

@Component
export default class UserVersionCardContent extends Vue {
  @Prop() version!: Version
  @Prop() fieldValueMethod!: Function
  @Prop() fieldValueAfterMethod!: Function
  @Prop() fieldValueChangedMethod!: Function
  @Prop() investmentsHash!: { [key: string]: string }
}
